import { Config, React, Link, _ } from 'utils';

export default function PageTitle() {
	return <div className="title-and-connected">
		<section id="page-title" className="fix">
			<h1>{_('Baza životopisa')}</h1>
		</section>
		<div className="title-bottom">
			<section className="breadcrumbs">
				<a href='/'>{_("Naslovnica")}</a> &rsaquo;
				<a href='/Poslodavci/'>{ _('Poslodavci')}</a> &rsaquo;
				<Link to={Config.baseUrl}>{_('Baza životopisa')}</Link>
			</section>
		</div>
	</div>;
}


// WEBPACK FOOTER //
// ./src/modules/app/pagetitle.js